import ActiveRecord from './active_record/base'

class Day extends ActiveRecord {
	static tableName = 'days'
}

export default Day
